import { API, axiosInstance } from "lib";

export const uploadFiles = (data = {}) => {
  return axiosInstance
    .patch(`${API.GUEST}/${data?.id}`, data?.payload, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      throw err;
    });
};
